import React, { memo } from "react";

import styles from "./style.css";

const Location = memo(props => {
  const { name, lat, lon, onClick } = props;

  return (
    <li class={styles.container} onClick={() => onClick({ lat, lng: lon, name })}>
      <div>
        <img src={`${window.GLOBALS.ASSETS.GENERIC}/img/location-marker.png`} />
      </div>
      <div>{name}</div>
    </li>
  );
});

export default Location;
